// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SET_SETTINGS = 'settings/SET_SETTINGS';

export enum NOTIFICATIONS_TABS {
    ADMIN_ONLY_TAB = '#admin-only',
    SERVER_OWNER_TAB = '#server-owner',
}

